import simpleCameraHelpers from './shaders/simpleCameraHelpers.glsl'
import cameraHelpers from './shaders/cameraHelpers.glsl'
import randomHelpers from './shaders/randomHelpers.glsl'
import defaultVertex from './shaders/defaultVertex.glsl'
import defaultFragment from './shaders/defaultFragment.glsl'
import voronoiNoise from './shaders/voronoiNoise.glsl'

export const shaderUtils = {
    simpleCameraHelpers, cameraHelpers, randomHelpers, defaultVertex, defaultFragment, voronoiNoise,
}
